import React, { lazy, Suspense } from 'react';
import { useBlossomEnabled } from './useBlossomEnabled';

// Code-split the 3D scene so first paint never waits on three.js.
const BlossomScene = lazy(() => import('./BlossomScene'));

const LazyBlossomScene = (props) => {
  const [enabled] = useBlossomEnabled();
  if (!enabled) return null;
  return (
    <Suspense fallback={null}>
      <BlossomScene {...props} />
    </Suspense>
  );
};

export default LazyBlossomScene;
